import React from "react";
import { Column, Columns, Table } from "@allxsmith/bestax-bulma";
import {readableDate} from "../../utils";



class PrintMissingFuel extends React.Component{




    render(){
        let rental = this.props.rental;

        let make = (rental && rental.vehicle) ? rental.vehicle.make ? rental.vehicle.make.name : "" : "";
        let model = (rental && rental.vehicle) ? rental.vehicle.model ? rental.vehicle.model.name : "" : "";
        let variant = (rental && rental.vehicle) ? rental.vehicle.variant : ""

        return (
            <div className={"print-landscape"}>
                <Columns isMultiline>
                    <h2 className="job-card-print-title" data-testid={"title-1"}>
                        {`Missing Fuel / Adblue - Rental ${rental ? rental.id : ""} - ${(rental && rental.vehicle) ? rental.vehicle.registration : ""}`}
                    </h2>
                </Columns>
                <Columns isMultiline>
                  <Column className="is-one-quarter">
                    <Table isBordered isFullwidth>
                        <tbody>
                            <tr>
                                <td className={"header-row"}>Registration</td>
                                <td data-testid={"vehicle-variant"}>{(rental && rental.vehicle) ? rental.vehicle.registration : ""}</td>
                            </tr>
                            <tr>
                                <td className="header-row">Make</td>
                                <td data-testid={"vehicle-make"}>{make}</td>
                            </tr>
                            <tr>
                                <td className="header-row">Model</td>
                                <td data-testid={"vehicle-model"}>{model}</td>
                            </tr>
                            <tr>
                                <td className={"header-row"}>Variant</td>
                                <td data-testid={"vehicle-variant"}>{variant}</td>
                            </tr>
                            <tr>
                                <td className={"header-row"}>Rental</td>
                                <td data-testid={"vehicle-variant"}>{rental ? rental.id : ""}</td>
                            </tr>
                            <tr>
                                <td className={"header-row"}>Customer</td>
                                <td data-testid={"vehicle-variant"}>{rental ? rental.customer ? rental.customer.display_name : "" : ""}</td>
                            </tr>
                            <tr>
                                <td className={"header-row"}>Off Hire Date</td>
                                <td data-testid={"vehicle-variant"}>{rental ? readableDate(rental.off_hire_date) : ""}</td>
                            </tr>
                        </tbody>
                    </Table>
                  </Column>
                  <Column>
                        <Table isFullwidth isBordered>
                            <thead>
                                <tr>
                                    <th>Missing Fuel (L)</th>
                                    <td className={"wide-column"}></td>
                                </tr>
                                <tr>
                                    <th>Missing Adblue (L)</th>
                                    <td className={"wide-column"}></td>
                                </tr>
                            </thead>
                        </Table>
                  </Column>
                </Columns>
            </div>
        );
    }

}

export default PrintMissingFuel